export default __webpack_public_path__ + "static/media/user-rounded12.96dae7de.svg";